import { Tag } from "antd";
import _ from "lodash";
import React from "react";
import { formatComma } from "../../frameworks/Util";


export default function AddListChemical(props) {
  const { target} = props;

  return (<ul>
      {target.inputs.map((item) => {
        return <li>{item.chemical} <Tag color="orange" style={{  marginLeft : 10, marginBottom : 5 }}>ปริมาณ : {formatComma(_.get(item, 'amount', '-'))}</Tag></li>
      })}
  </ul>
  )
}